import React from 'react';

export const DiscordBadgeIcon = ({ width = 160, height = 160 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_421_540)">
      <path
        d="M54.1461 21.5118C69.1281 9.04601 90.8719 9.04601 105.854 21.5118C109.392 24.4557 113.407 26.7736 117.725 28.3657C136.012 35.1076 146.884 53.9384 143.579 73.1461C142.799 77.682 142.799 82.318 143.579 86.8539C146.884 106.062 136.012 124.892 117.725 131.634C113.407 133.226 109.392 135.544 105.854 138.488C90.8719 150.954 69.1281 150.954 54.1461 138.488C50.608 135.544 46.5932 133.226 42.2747 131.634C23.988 124.892 13.1161 106.062 16.4208 86.8539C17.2012 82.318 17.2012 77.682 16.4208 73.1461C13.1161 53.9384 23.988 35.1076 42.2747 28.3657C46.5932 26.7736 50.608 24.4557 54.1461 21.5118Z"
        fill="#F3F3F5"
      />
      <path
        d="M54.1461 21.5118C69.1281 9.04601 90.8719 9.04601 105.854 21.5118C109.392 24.4557 113.407 26.7736 117.725 28.3657C136.012 35.1076 146.884 53.9384 143.579 73.1461C142.799 77.682 142.799 82.318 143.579 86.8539C146.884 106.062 136.012 124.892 117.725 131.634C113.407 133.226 109.392 135.544 105.854 138.488C90.8719 150.954 69.1281 150.954 54.1461 138.488C50.608 135.544 46.5932 133.226 42.2747 131.634C23.988 124.892 13.1161 106.062 16.4208 86.8539C17.2012 82.318 17.2012 77.682 16.4208 73.1461C13.1161 53.9384 23.988 35.1076 42.2747 28.3657C46.5932 26.7736 50.608 24.4557 54.1461 21.5118Z"
        fill="url(#paint0_linear_421_540)"
        fill-opacity="0.6"
      />
    </g>
    <path
      d="M54.4659 21.8962C69.2626 9.58456 90.7374 9.58456 105.534 21.8962C109.116 24.8764 113.18 27.2231 117.552 28.8349C135.613 35.4934 146.35 54.0912 143.086 73.0613C142.296 77.6534 142.296 82.3466 143.086 86.9387C146.35 105.909 135.613 124.507 117.552 131.165C113.18 132.777 109.116 135.124 105.534 138.104C90.7374 150.415 69.2626 150.415 54.4659 138.104C50.8841 135.124 46.8196 132.777 42.4477 131.165C24.3872 124.507 13.6497 105.909 16.9135 86.9387C17.7036 82.3466 17.7036 77.6534 16.9135 73.0613C13.6497 54.0912 24.3872 35.4934 42.4477 28.8349C46.8196 27.2231 50.8841 24.8764 54.4659 21.8962Z"
      stroke="#90909E"
    />
    <path
      d="M107.768 53.36C102.589 50.856 97.0519 49.0362 91.263 48C90.552 49.3284 89.7215 51.1151 89.1488 52.5364C82.995 51.58 76.8978 51.58 70.8572 52.5364C70.2846 51.1151 69.4352 49.3284 68.7179 48C62.9227 49.0362 57.3792 50.8627 52.2006 53.3732C41.7555 69.6854 38.924 85.5924 40.3397 101.274C47.2675 106.62 53.9814 109.868 60.5819 111.993C62.2116 109.675 63.6651 107.211 64.9173 104.614C62.5325 103.678 60.2484 102.522 58.0902 101.181C58.6628 100.742 59.2229 100.284 59.7639 99.8124C72.9273 106.175 87.2297 106.175 100.236 99.8124C100.783 100.284 101.343 100.742 101.909 101.181C99.7449 102.529 97.4546 103.685 95.0699 104.621C96.322 107.211 97.7692 109.682 99.4052 112C106.012 109.875 112.732 106.627 119.66 101.274C121.321 83.0951 116.822 67.3342 107.768 53.36ZM66.7106 91.6298C62.7591 91.6298 59.5185 87.8174 59.5185 83.1748C59.5185 78.5322 62.6899 74.7132 66.7106 74.7132C70.7314 74.7132 73.9719 78.5255 73.9027 83.1748C73.9089 87.8174 70.7314 91.6298 66.7106 91.6298ZM93.2891 91.6298C89.3376 91.6298 86.0971 87.8174 86.0971 83.1748C86.0971 78.5322 89.2683 74.7132 93.2891 74.7132C97.3099 74.7132 100.55 78.5255 100.481 83.1748C100.481 87.8174 97.3099 91.6298 93.2891 91.6298Z"
      fill="#1E1E22"
    />
    <g filter="url(#filter1_i_421_540)">
      <path
        d="M54.1461 21.5118C69.1281 9.04601 90.8719 9.04601 105.854 21.5118V21.5118C109.392 24.4557 113.407 26.7736 117.725 28.3657V28.3657C136.012 35.1076 146.884 53.9384 143.579 73.1461V73.1461C142.799 77.682 142.799 82.318 143.579 86.8539V86.8539C146.884 106.062 136.012 124.892 117.725 131.634V131.634C113.407 133.226 109.392 135.544 105.854 138.488V138.488C90.8719 150.954 69.1281 150.954 54.1461 138.488V138.488C50.608 135.544 46.5932 133.226 42.2747 131.634V131.634C23.988 124.892 13.1161 106.062 16.4208 86.8539V86.8539C17.2012 82.318 17.2012 77.682 16.4208 73.1461V73.1461C13.1161 53.9384 23.988 35.1076 42.2747 28.3657V28.3657C46.5932 26.7736 50.608 24.4557 54.1461 21.5118V21.5118Z"
        stroke="#90909E"
        stroke-width="4"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_421_540"
        x="15.8318"
        y="12.1625"
        width="128.336"
        height="138.532"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.85716" />
        <feGaussianBlur stdDeviation="2.85716" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_421_540"
        />
      </filter>
      <filter
        id="filter1_i_421_540"
        x="13.8316"
        y="10.1625"
        width="132.337"
        height="151.104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11.4286" />
        <feGaussianBlur stdDeviation="11.4286" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_421_540"
        />
      </filter>
      <linearGradient
        id="paint0_linear_421_540"
        x1="1.28166e-06"
        y1="-2"
        x2="123.686"
        y2="44.975"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
